module.exports = __webpack_public_path__ + "img/medecin_explique.7d072f29.jpg";